import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Tag } from "lucide-react";
import { buildWhatsAppLink } from "../../lib/translations";
import { useLang } from "../../lib/LangContext";
import { navigateAndScroll } from "../../lib/scroll";
import { WA_PATH } from "../../lib/waIcon";
import { useNearSections } from "../../lib/useNearSections";

export const FloatingWhatsApp = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const near = useNearSections();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goQuote = () => navigateAndScroll(navigate, "contact", { flow: "price" });

  // Hide on the PUREGARAGE cinematic landing to keep it clean
  if (location.pathname === "/app" || location.pathname.startsWith("/app/")) return null;

  return (
    <div
      data-testid="floating-cta"
      className={`hidden md:flex fixed bottom-6 right-6 z-40 items-center gap-2 transition-[opacity,transform] duration-500 ${
        show && !near ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
      aria-hidden={!show || near}
    >
      <a
        data-testid="floating-whatsapp-bubble"
        href={buildWhatsAppLink("Hi PUREGLOSS! ")}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        tabIndex={show && !near ? 0 : -1}
        className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#0A0A0C]/90 backdrop-blur border border-white/15 text-[#25D366] hover:border-[#25D366]/60 transition-colors"
      >
        <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d={WA_PATH} />
        </svg>
      </a>
      <button
        type="button"
        data-testid="floating-cta-quote"
        onClick={goQuote}
        tabIndex={show && !near ? 0 : -1}
        className="group inline-flex items-center gap-2 h-10 bg-gold text-black px-4 rounded-full font-semibold text-[11px] tracking-[0.18em] uppercase shadow-[0_8px_28px_-12px_rgba(212,175,55,0.7)] hover:bg-[#f3e5ab] transition-colors"
        aria-label={t.cta.getPrice}
      >
        <Tag size={14} />
        {t.cta.getPriceShort}
      </button>
    </div>
  );
};
